import axios from "axios";
import { API_PATHS } from "@config/constants";
import { getUserinfo } from "@utils/localStorage";
import { isLoggedIn } from "@utils/cookie";

export const loginApi = async (userInfo) => {
  const { data, status } = await axios.post(API_PATHS.login, userInfo);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't login!");
  }

  return data;
};

export const registerApi = async (userInfo) => {
  const { data, status } = await axios.post(API_PATHS.register, userInfo);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't register!");
  }

  return data;
};

export const verifyOTPApi = async (dataVerify) => {
  const { data, status } = await axios.post(API_PATHS.verify, dataVerify);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Error OTP!");
  }

  return data;
};

export const requestOTP = async (dataIsdn) => {
  const { data, status } = await axios.post(API_PATHS.getOTP, dataIsdn);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't get OTP!");
  }

  return data;
};

export const requestOtpPackage = async (dataIsdn) => {
  const { data, status } = await axios.post(
    API_PATHS.requestOtpPackage,
    dataIsdn
  );
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't get OTP!");
  }

  return data;
};

export const verifyOtpPackage = async (dataIsdn) => {
  const { data, status } = await axios.post(
    API_PATHS.verifyOtpPackage,
    dataIsdn
  );
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "OTP is not correct!");
  }

  return data;
};

// Change to use cookie to  validate use local
// axios.interceptors.request.use(function (config) {
//   const user = getUserinfo();
//   config.headers.Authorization = `Bearer ${user?.token?.accessToken}`;
//   return config;
// }, function (error) {
//   return Promise.reject(error);
// });

export const getUserApi = async () => {
  try {
    if (isLoggedIn()) {
      const { data, status } = await axios.get(API_PATHS.getUser);
      if (status !== 200) {
        return null;
      }

      return data.data;
    } else {
      return;
    }
  } catch (e) {
    return null;
  }
};

export const getBidHistoryApi = async ({ queryKey }) => {
  const [, { page, pageSize }] = queryKey;

  try {
    const { data, status } = await axios.get(
      `${API_PATHS.getBidHistory}?pageSize=${pageSize}&current=${page}`
    );
    if (status !== 200) {
      return null;
    }

    return data;
  } catch (e) {
    return null;
  }
};

export const getTurnRemainApi = async () => {
  try {
    if (isLoggedIn()) {
      const { data, status } = await axios.get(API_PATHS.getRemainTurn);
      if (status !== 200) {
        return null;
      }

      return data.data;
    } else {
      return;
    }
  } catch (e) {
    return null;
  }
};

export const registerPack = async (dataRegister) => {
  try {
    const { data, status } = await axios.post(
      API_PATHS.registerPack,
      dataRegister
    );
    if (status !== 200) {
      return null;
    }

    return data.data;
  } catch (e) {
    return null;
  }
};

export const bidApi = async (bidInfo) => {
  const { data, status } = await axios.post(API_PATHS.bid, bidInfo);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't bid");
  }

  return data;
};

export const changePasswordApi = async (user) => {
  const { data, status } = await axios.post(API_PATHS.updatePassword, user);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't change password");
  }

  return data.data;
};

export const updateInformationApi = async (user) => {
  const { data, status } = await axios.post(API_PATHS.updateInformation, user);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't update information");
  }

  return data.data;
};

export const logoutApi = async () => {
  const { data, status } = await axios.post(API_PATHS.logout);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't logout");
  }

  return data.data;
};

export const viewInfoWinner = async (product) => {
  const { data, status } = await axios.get(
    `${API_PATHS.viewInfoWinner}/${product.cp_id}`
  );
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't view information winner");
  }
  return data;
};

export const detectPhoneApi = async () => {
  const { data, status } = await axios.post(`${API_PATHS.detectMsisdn}`);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't detect phone");
  }
  return data.data;
};

export const getPackageListApi = async ({ queryKey }) => {
  const [, { page, pageSize, status }] = queryKey;
  let url = `${API_PATHS.getPackageList}?pageSize=${pageSize}&current=${page}&status=${status}`
  if (status === "all" || (!status && status !== 0)) {
    url = `${API_PATHS.getPackageList}?pageSize=${pageSize}&current=${page}`
  }

  try {
    const { data, status } = await axios.get(url);
    if (status !== 200) {
      return null;
    }

    return data;
  } catch (e) {
    return null;
  }
};


export const getListRankEventNewYear = async ({ queryKey }) => {
  const [, { page, limit, my_rank }] = queryKey;

  let url = `${API_PATHS.eventGetRank}?limit=${limit}&page=${page}`;

  if (my_rank){
   url = `${API_PATHS.eventGetRank}?limit=${limit}&page=${page}&my_rank=${my_rank}`;
  }
    try {
      const { data, status } = await axios.get(url);
      if (status !== 200) {
        return null;
      }

      return data?.data;
    } catch (e) {
      return null;
    }
};
